import axios from 'axios'
import config from '@/config'

async function getAll (jwt, pbKey) {
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${jwt}`
    }
  }
  const response = await axios.get(config.host + '/public/id/' + pbKey, axiosConfig)
  return response
}

async function getAllPayloads (params) {
  const config2 = {
    headers: {
      Authorization: 'Bearer ' + this.$store.jwt
    },
    params
  }
  const response = await axios.get(config.host + '/payloads', config2)
  return response
}

export default {
  getAll: getAll,
  getAllPayloads: getAllPayloads
}
